import { toggleMark } from 'prosemirror-commands';
import { isMarkActive } from './marks';
export function defineActions(actions) {
    return actions;
}
export function createToggleMarkAction(markType) {
    const command = toggleMark(markType);
    return {
        isActive: (state) => Boolean(isMarkActive(state, markType)),
        isEnable: command,
        run: command,
    };
}
